import React, { useEffect, useRef, createElement } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
export function Testimonial() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  // Load Vimeo player script
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <section ref={ref} className="w-full py-20 px-4 bg-navy-light" data-id="element-470">
      <div className="max-w-4xl mx-auto" data-id="element-471">
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 50
      }} transition={{
        duration: 0.8
      }} className="relative bg-gradient-to-br from-navy-dark to-navy border border-gold/20 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-472">
          <QuoteIcon className="absolute top-6 left-6 h-12 w-12 text-gold/20" aria-hidden="true" data-id="element-473" />

          <div className="relative z-10" data-id="element-474">
            <h2 className="font-heading font-bold text-2xl md:text-3xl mb-6 text-gold" data-id="element-475">
              Lo que Pasó Cuando un Miembro Siguió el Sistema por Primera Vez
            </h2>

            <div className="mb-8 rounded-xl overflow-hidden border border-gold/10" data-id="element-476">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-477">
                <iframe src="https://player.vimeo.com/video/1177040592?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="AI WEBSITE TESTIMONIO" data-id="element-478" />
              </div>
            </div>

            <blockquote className="font-body text-lg md:text-xl text-gray-300 leading-relaxed mb-6 italic" data-id="element-479">
              "La primera semana hice una lista de 7 negocios cerca de mi casa
              que no tenían sitio web. Usé el cerebro de IA para construir una
              demo de cada uno. Llamé a los 7. Tres me dijeron que sí. Cobré
              $350 por cada uno. En 7 días tenía{' '}
              <span className="text-gold font-bold not-italic" data-id="element-480">$1,050</span> en
              mi cuenta. Nunca había hecho algo así."
            </blockquote>

            <footer className="font-body text-sm text-gray-400" data-id="element-481">
              — Miembro de AI Web Closer
            </footer>
          </div>

          <motion.p initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {
          opacity: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="font-body text-base text-gray-400 mt-8 pt-6 border-t border-gold/10" data-id="element-482">
            Esto no es un caso excepcional. Es lo que pasa cuando sigues un
            sistema probado.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}